import {getSharedCookieDomain} from 'src/lib/shared-cookie-domain'
import {PORTAL_MODULE_PREFS_COOKIE_KEY, type PortalModulePrefs, parsePortalModulePrefs, serializePortalModulePrefs} from './portal-module-prefs'

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

function readCookieValue(): string | null {
  const escapedKey = PORTAL_MODULE_PREFS_COOKIE_KEY.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedKey}=([^;]*)`))
  return match?.[1] ?? null
}

export function readPortalModulePrefsFromClientCookie(): PortalModulePrefs {
  return parsePortalModulePrefs(readCookieValue())
}

export function writePortalModulePrefsToClientCookie(prefs: PortalModulePrefs) {
  const secure = window.location.protocol === 'https:'
  const domain = getSharedCookieDomain()
  const encodedValue = encodeURIComponent(serializePortalModulePrefs(prefs))

  let cookie = `${PORTAL_MODULE_PREFS_COOKIE_KEY}=${encodedValue}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; samesite=lax`

  if (secure) cookie += '; secure'
  if (domain) cookie += `; domain=${domain}`

  document.cookie = cookie
}
